import { EEntranceType } from '../../../../json_query';
import { changeEntrance } from '../../../state/advanced/entrance';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const Entrance = getMultiSelectParam<EEntranceType>(
  'Вход',
  [
    { title: 'Отдельный со двора', value: EEntranceType.SeparateCourtyard },
    { title: 'Отдельный с улицы', value: EEntranceType.SeparateStreet },
    { title: 'Общий со двора', value: EEntranceType.CommonCourtyard },
    { title: 'Общий с улицы', value: EEntranceType.CommonStreet },
  ],
  'input_type',
  changeEntrance,
);
